module.exports = __webpack_public_path__ + "img/wiegeartikel.519e8e37.svg";